import { createSelector } from '@reduxjs/toolkit'

import { TAnalysisTypeResponse } from 'redux/api/AnalysisTypes'

import { ApplicationState } from 'redux/Stores/types'

export const selectAnalysisTypes = createSelector(
  [(state: ApplicationState) => state.AnalysisTypeStore.analysisTypes],
  (analysisTypes): TAnalysisTypeResponse[] =>
    [...analysisTypes].sort((a, b) => a.name.localeCompare(b.name, 'sv'))
)

export const selectAnalysisType = createSelector(
  [
    (state: ApplicationState) => state.AnalysisTypeStore.analysisTypes,
    (_: ApplicationState, key: string | null) => key
  ],
  (analysisTypes, key): TAnalysisTypeResponse | null =>
    key ? analysisTypes.find((item) => item.id === key) ?? null : null
)

export const selectAnalysisTypesFetchStatus = (state: ApplicationState) =>
  state.AnalysisTypeStore.fetchStatus

export const selectAnalysisTypeRealEstates = (state: ApplicationState) =>
  state.AnalysisTypeStore.realEstates

export const selectAnalysisTypeRealEstatesFetchStatus = (
  state: ApplicationState
) => state.AnalysisTypeStore.realEstatesFetchStatus
